import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import BHome from './components/BHome';
import Index from './components/Index';
import Signup from './components/Dashboard/Signup';
import Login from './components/Dashboard/Login';
import NotFoundPage from './components/NotFoundPage';
import VisitAgain from './components/VisitAgain';
import PrivateRoute from './components/PrivateRoute';
import QR from './components/QR';
import Loader from './components/Loader';

function App() {
  console.log('%cWelcome to ClickStar!', 
    'font-size: 24px; color: #4CAF50; font-weight: bold; text-align: center; padding: 10px; border-radius: 5px; background-color: #e3f2fd;');
    const webtitle = "ClickStar : Simplify Reviews, Amplify Stars";
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/business/dashboard/*" element={<PrivateRoute>
            <Dashboard title={`Dashboard  | ${webtitle}`} />
          </PrivateRoute>} />
          <Route path="/" element={<Index title={` ${webtitle}`}/>} />
          <Route path="/review/:slug" element={<BHome title={`${webtitle}`}/>}></Route>
          <Route path="/review/QR/:slug" element={<QR/>}></Route>
          <Route path="/business/signup" element={<Signup title={`Signup | ${webtitle}`}/>} />
          <Route path="/business/login" element={<Login title={`Login | ${webtitle}`} />} />
          <Route path="/visitagain" element={<VisitAgain title={`Visit Again | ${webtitle}`} />} />
          <Route path="Loading" element={<Loader/>} />
          <Route path="*" element={<NotFoundPage title={`404 You Are Lost | ${webtitle}`}/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
